import React from 'react';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';

export const VpHookFormWrapper = ({ children, onSubmit, formData = {}, keepDirty = false }) => {
  const form = useForm(formData);

  const onSubmitHandler = (data, e) => {
    onSubmit(data, e);
    form.reset({ ...data }, { keepDirty });
  };

  return (
    <FormProvider {...form}>
      <form
        onSubmit={(e) => {
          e.stopPropagation();

          return form.handleSubmit(onSubmitHandler)(e);
        }}
      >
        {children}
      </form>
    </FormProvider>
  );
};

VpHookFormWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  onSubmit: PropTypes.func.isRequired,
  formData: PropTypes.object,
  keepDirty: PropTypes.bool
};

export default VpHookFormWrapper;



// WEBPACK FOOTER //
// ./src/vp-ui/wrappers/VpHookFormWrapper.jsx